export { default as asAddContactTagActionProps } from './asAddContactTagActionProps';
export { default as asAddContactTagActionInput } from './asAddContactTagActionInput';
export { default as AddContactTagActionComponent } from './AddContactTagActionComponent';
export { default as describeAddContactTagAction } from './describeAddContactTagAction';
export { default as defaultNewAddContactTagActionProps } from './defaultNewAddContactTagActionProps';
